function timestampToFormattedDate(timestamp) {
    var date = new Date(timestamp);

    var day = date.getDate();
    day = String(day).length == 1 ? "0" + day : day;
    var month = date.getMonth() + 1;
    month = String(month).length == 1 ? "0" + month : month;
    var year = date.getFullYear();

    return day + '/' + month + '/' + year;
}

export { timestampToFormattedDate };


// WEBPACK FOOTER //
// ./src/utils/Date/DateUtils.js